import {Component,HostListener} from '@angular/core';
import {MessagingService} from './services/messagingService';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from './services/SharedService';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: []
})
export class AppComponent {
  title = 'nexttotalFE';
  message;
   idleTimeoutInSeconds = 300; // e.g., 5 minutes
  private idleTimer: any;

  constructor(private messagingService: MessagingService, private router: Router, private shareService: SharedService) {
  }
 convertToSeconds(value: string): number {
  switch (value) {
    case '5min':
      return 5 * 60;
    case '10min':
      return 10 * 60;
    case '30min':
      return 30 * 60;
    case '1hr':
      return 60 * 60;
    case 'never':
    default:
      return Infinity; // Or 0, depending on your logic
  }
}
  ngOnInit() {
  //   let general_settings = JSON.parse(decodeURIComponent(escape(atob(window.localStorage.getItem(btoa('general_settings'))))));
  //  if (general_settings.lockSystemAccess){
  //     this.startIdleTimer();
  //     this.idleTimeoutInSeconds = this.convertToSeconds(general_settings.logoutAfterInactivity);
  //  }

  try {
  const encodedSettings = window.localStorage.getItem(btoa('general_settings'));
  if (encodedSettings) {
    // safer UTF-8 Base64 decode helper
    const utf8Decode = (str) => decodeURIComponent(
      Array.prototype.map.call(atob(str), c =>
        '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      ).join('')
    );

    const decoded = utf8Decode(encodedSettings);
    const general_settings = JSON.parse(decoded);

    if (general_settings.lockSystemAccess) {
      this.startIdleTimer();
      this.idleTimeoutInSeconds = this.convertToSeconds(general_settings.logoutAfterInactivity);
    }
  }
} catch (error) {
  console.error('Failed to decode general_settings:', error);
}
    
    this.messagingService.receiveMessage();
    this.messagingService.currentMessage.subscribe((response) => {
      this.message = response;

      if (this.message) {

        if(this.message.data.type == 'kitchen'){

            this.shareService.kitchenScreen.next();

        }else if(this.message.data.type == 'serving_number'){

            this.shareService.servingNumber.next(this.message.data.data);

        }else{

            if (this.message.data.data) {
                const register = JSON.parse(this.message.data.data);
              window.localStorage.setItem(btoa('register'), btoa(JSON.stringify(register.register)));
            } else {
                window.localStorage.removeItem(btoa('register'));
            }
            location.reload(true);
        }
      }

    });

     this.shareService.getOrderUpdate.next();

  }

  @HostListener('window:mousemove')
  @HostListener('window:keydown')
  @HostListener('window:click')
  @HostListener('window:touchstart')
  resetTimer() {
    clearTimeout(this.idleTimer);
    this.startIdleTimer();
  }

  startIdleTimer() {
    
    this.idleTimer = setTimeout(() => {
      console.log('User is idle. Logging out...');
      this.logout(); // Or redirect
    }, this.idleTimeoutInSeconds * 1000);
  }
 logout() {
    // Perform logout logic or redirect
    this.router.navigate(['/locking']);
  }

}
